import { LoadProductsBoughtUsecase, LoadProductsBoughtUsecaseImp } from 'domain/usecases/load-products-bought-usecase';
import { makeHttpLoadProductsBoughtRepository } from '../repositories/http/product-http-repository-factory';

export const makeLoadProductsBoughtUsecase = (): LoadProductsBoughtUsecase => {
  return new LoadProductsBoughtUsecaseImp(makeHttpLoadProductsBoughtRepository());
};
